import { VerifierType, VerifierTypeOfGovernment } from 'src/api';
import type { AddressFieldsFormValues } from 'src/constants/address';
import type { SelectFieldOption } from 'src/types/components';

// InitialStepForm

export enum InitialStepFormFields {
  firstName = 'firstName',
  lastName = 'lastName',
  email = 'email',
  phoneNumber = 'phoneNumber',
  password = 'password',
  passwordConfirm = 'passwordConfirm',
  isEmailFree = 'isEmailFree',
}

export type InitialStepFormValues = {
  [InitialStepFormFields.firstName]: string;
  [InitialStepFormFields.lastName]: string;
  [InitialStepFormFields.email]: string;
  [InitialStepFormFields.phoneNumber]: string;
  [InitialStepFormFields.password]: string;
  [InitialStepFormFields.passwordConfirm]: string;
  [InitialStepFormFields.isEmailFree]?: boolean;
};

// EmailConfirmationForm

export enum EmailConfirmationFormFields {
  emailConfirmationCode = 'emailConfirmationCode',
}

export type EmailConfirmationFormValues = {
  [EmailConfirmationFormFields.emailConfirmationCode]: string;
};

// Related Company

export type RelatedVerifier = {
  id: string;
  createdAt?: string;
  displayName?: string;
  logo?: {
    downloadUrl: string;
  };
  type?: VerifierType;
  address?: {
    state: string;
    street: string;
  };
};

// VerifierAccountTypeForm

export enum VerifierAccountTypeFormFields {
  accountType = 'accountType',
  permissiblePurposeReferenceId = 'permissiblePurposeReferenceId',
  isRulesRead = 'isRulesRead',
}

export type VerifierAccountTypeFormValues = {
  [VerifierAccountTypeFormFields.accountType]: VerifierType;
  [VerifierAccountTypeFormFields.permissiblePurposeReferenceId]: string;
  [VerifierAccountTypeFormFields.isRulesRead]: boolean;
};

// VerifierBasicInfoForm

export enum VerifierBasicInfoFormFields {
  accountType = 'accountType',
  permissiblePurposeReferenceId = 'permissiblePurposeReferenceId',
  companyDisplayInfo = 'companyDisplayInfo',
  primaryContactEmail = 'primaryContactEmail',
  primaryContactPhone = 'primaryContactPhone',
  fein = 'fein',
  commercialName = 'commercialName',
  industry = 'industry',
  street = 'street',
  city = 'city',
  county = 'county',
  state = 'state',
  zipCode = 'zipCode',
  websiteUrl = 'websiteUrl',
}

export enum CommercialVerifierBasicInfoFormFields {
  registeredBusinessName = 'registeredBusinessName',
}

export enum GovernmentVerifierBasicInfoFormFields {
  governmentEntityName = 'governmentEntityName',
  typeOfGovernment = 'typeOfGovernment',
  governmentDepartment = 'governmentDepartment',
}

export type VerifierBasicInfoFormValues = {
  [VerifierBasicInfoFormFields.accountType]: VerifierType;
  [VerifierBasicInfoFormFields.permissiblePurposeReferenceId]: string;
  [VerifierBasicInfoFormFields.companyDisplayInfo]: string;
  [VerifierBasicInfoFormFields.primaryContactEmail]: string;
  [VerifierBasicInfoFormFields.primaryContactPhone]: string;
  [VerifierBasicInfoFormFields.fein]: string;
  [VerifierBasicInfoFormFields.commercialName]: string;
  [VerifierBasicInfoFormFields.industry]: SelectFieldOption;
  [VerifierBasicInfoFormFields.websiteUrl]: string;
} & AddressFieldsFormValues;

export type CommercialVerifierBasicInfoFormValues = {
  [CommercialVerifierBasicInfoFormFields.registeredBusinessName]: string;
};

export type GovernmentVerifierBasicInfoFormValues = {
  [GovernmentVerifierBasicInfoFormFields.governmentEntityName]: string;
  [GovernmentVerifierBasicInfoFormFields.typeOfGovernment]: VerifierTypeOfGovernment;
  [GovernmentVerifierBasicInfoFormFields.governmentDepartment]: string;
};

export type VerifierFormValues = InitialStepFormValues &
  VerifierAccountTypeFormValues &
  VerifierBasicInfoFormValues;

// NoticeToFurnishersForm

export enum NoticeToFurnishersFormFields {
  isRulesRead = 'isRulesRead',
}

export type NoticeToFurnishersFormValues = {
  [NoticeToFurnishersFormFields.isRulesRead]: boolean;
};
